import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ADMIN_DOMAIN, PATIENT_DOMAIN } from '../config/domains';

function DomainRedirect() {
  const location = useLocation();
  const navigate = useNavigate();
  const hostname = window.location.hostname;

  useEffect(() => {
    // Skip redirects on localhost / dev environments
    if (hostname === 'localhost' || hostname === '127.0.0.1') return;

    const path = location.pathname;
    const search = location.search || '';
    const hash = location.hash || '';

    // On admin subdomain: strip /admin prefix for clean URLs
    if (hostname === ADMIN_DOMAIN) {
      if (path === '/admin') {
        navigate('/', { replace: true });
        return;
      }
      if (path.startsWith('/admin/')) {
        const cleanPath = path.replace(/^\/admin/, '') + search + hash;
        navigate(cleanPath, { replace: true });
        return;
      }
    }

    // On patient subdomain: redirect admin routes to admin domain (clean URLs)
    if (hostname === PATIENT_DOMAIN) {
      if (path === '/admin') {
        window.location.href = `https://${ADMIN_DOMAIN}/`;
        return;
      }
      if (path.startsWith('/admin/')) {
        // Strip /admin prefix — redirect to clean URL on admin domain
        const cleanPath = path.replace(/^\/admin/, '') + search + hash;
        window.location.href = `https://${ADMIN_DOMAIN}${cleanPath}`;
        return;
      }
    }
  }, [hostname, location, navigate]);

  return null;
}

export default DomainRedirect;
